<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.empresa"
        ref="RkmDataTable"
    />
</template>

<script>
export default {
    computed: {
        fields() {
            return [
                {key: 'empresa_nome', label: 'Nome', name: 'cadastro_empresa.nome', searchable: true, sortable: true},
                {key: 'empresa_site', label: 'Site', name: 'cadastro_empresa.site', searchable: true, sortable: true},
            ]
        },
    },
    inject: ['repositories'],
}
</script>